module.exports = __webpack_public_path__ + "img/democratic_republic_of_the_congo.b632b4b.webp";